const menuHasChildren = document.querySelectorAll('.m-slideOut .menu-item-has-children');

function toggleSubMenu(el) {
  el.currentTarget.classList.toggle('open');
}

menuHasChildren.forEach((link) => {
  link.addEventListener('click', toggleSubMenu);
})
